import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MaskLines } from "./Reveal";
import { TiltBook } from "./TiltBook";
import { Sun, Plane, Squiggle } from "./Doodles";

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const ySun = useTransform(scrollYProgress, [0, 1], [0, -120]);
  const yPlane = useTransform(scrollYProgress, [0, 1], [0, -220]);
  const yBook = useTransform(scrollYProgress, [0, 1], [0, 90]);

  return (
    <section id="top" ref={ref} className="relative min-h-screen bg-ink text-cream overflow-hidden pt-32 pb-20 grain">
      <motion.div style={{ y: ySun }} className="absolute bottom-6 right-4 sm:bottom-10 sm:right-10 text-cream/70 pointer-events-none">
        <Sun className="w-20 sm:w-28 animate-spin-slow" />
      </motion.div>
      <motion.div style={{ y: yPlane }} className="absolute top-40 right-6 sm:right-16 text-cream/70">
        <Plane className="w-20 sm:w-32" />
      </motion.div>
      <Squiggle className="absolute bottom-10 left-6 w-40 text-butter/60" />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-12 gap-14 lg:gap-8 items-center">
        <div className="lg:col-span-7">
          <motion.p
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2, duration: 0.8 }}
            className="font-hand text-2xl sm:text-3xl text-mint mb-4"
          >
            Hey! I'm Reuben, and I wrote a book.
          </motion.p>
          <h1 className="font-display text-butter text-[3.4rem] sm:text-7xl lg:text-[6rem] xl:text-[6.75rem] leading-[0.92] tracking-wide">
            <MaskLines lines={["Stories,", "laughs &", "wild adventures."]} lineClass="[&:nth-child(1)]:text-butter" />
          </h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.9, duration: 0.9 }}
            className="mt-8 max-w-xl text-base sm:text-lg text-cream/85 leading-relaxed"
          >
            Welcome to Reuben's Reads. My first book, <span className="text-butter font-bold">The Party Pet Shop</span>,
            is a funny story about a pet shop that is definitely not your average pet shop.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.1, duration: 0.9 }}
            className="mt-10 flex flex-wrap items-center gap-4"
          >
            <a href="#buy" data-testid="hero-buy-button"
              className="group inline-flex items-center gap-3 rounded-full bg-butter text-ink font-bold text-lg px-8 py-4 hover:bg-coral hover:text-cream transition-colors duration-300">
              Buy the book · £6
              <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">→</span>
            </a>
            <a href="#book" data-testid="hero-read-more-link" className="text-cream/80 font-semibold underline decoration-butter decoration-2 underline-offset-8 hover:text-butter transition-colors">
              What's it about?
            </a>
          </motion.div>
        </div>
        <motion.div style={{ y: yBook }} className="relative z-10 lg:col-span-5">
          <TiltBook />
        </motion.div>
      </div>
    </section>
  );
};
